import { FacilityBookingList } from './FacilityBookingList'
import { FacilityBookingEdit } from './FacilityBookingEdit'

export { FacilityBookingList, FacilityBookingEdit }


// WEBPACK FOOTER //
// ./src/components/facilitybooking/index.js